import React, { useState, useEffect } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import api from "../../../api/api";

const KycForm = () => {
  const { register, handleSubmit } = useForm();

  const handleSub = (data) => {
    api.patch('/users/me/', data)
    .then(response=> {
        toast.success("KYC Form Registered Successfully")
       
    }).catch(err=> {
      toast.error("Something went wrong")
    })
  };

  return (
    <div>
      <section className="max-w-10/12 m-auto mt-3 pb-10 rounded-lg bg-rose-100">
        <div className="text-center">
          <h1 className="5 text-primary-blue mx-auto whitespace-pre-wrap px-2 py-1 font-bold sm:!text-3xl">
            KYC Form
          </h1>

          <form
            onSubmit={handleSubmit(handleSub)}
            className="mx-auto flex w-11/12 flex-col rounded-md border-2 border-primary-red text-primary-blue lg:p-16 "
          >
            <div className="bg-primary-blue mt-5">
              <h1 className="py-2 px-3 text-left text-base font-bold text-white md:text-xl">
                Personal Information
              </h1>
            </div>
            <div className="mt-5 flex flex-col  gap-2 px-6  md:px-6 lg:px-0">
              <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
                <div className="flex flex-col space-y-2">
                  <label htmlFor="c-name" className="text-left font-semibold">
                    First Name<span className="text-primary-red">*</span>
                  </label>

                  <input
                    required=""
                    type="text"
                    placeholder="First Name"
                    className="border-primary-red border p-3"
                    {...register("f_name", { required: true })}
                  />
                </div>
                <div className="flex flex-col space-y-2">
                  <label htmlFor="c-name" className="text-left font-semibold">
                    Last Name<span className="text-primary-red">*</span>
                  </label>
                  <input
                    required=""
                    type="text"
                    placeholder="Nast Name"
                    className="border-primary-red border p-3"
                    {...register("l_name", { required: true })}
                  />
                </div>
                <div className="flex flex-col space-y-2">
                  <label htmlFor="c-name" className="text-left font-semibold">
                    Email<span className="text-primary-red">*</span>
                  </label>
                  <input
                    required=""
                    type="email"
                    placeholder="Email"
                    className="border-primary-red border p-3"
                    {...register("email", { required: true })}
                  />
                </div>

                <div className="flex flex-col space-y-2">
                  <label htmlFor="c-name" className="text-left font-semibold">
                    Phone no.<span className="text-primary-red">*</span>
                  </label>
                  <input
                    required=""
                    type="number"
                    placeholder="Phone"
                    className="border-primary-red border p-3"
                    {...register("phone", { required: true })}
                  />
                </div>
                <div className="flex flex-col items-start space-y-2">
                  <label htmlFor="c-name" className="text-left font-semibold">
                    Gender<span className="text-primary-red">*</span>
                  </label>
                  <div className="flex items-center gap-2">
                    <label className="text-primary-blue font-semibold" htmlFor="">
                      Male
                    </label>
                    <input
                      type="radio"
                      name="gender"
                      id=""
                      value="M"
                      {...register("gender", { required: true })}
                    />
                  </div>
                  <div className="flex items-center gap-3">
                    <label
                      htmlFor=""
                      className="text-primary-blue font-semibold"
                    >
                      Female
                    </label>
                    <input
                      type="radio"
                      name="gender"
                      id=""
                      value="F"
                      {...register("gender", { required: true })}
                    />
                  </div>
                </div>

                <div className="flex flex-col space-y-2">
                  <label htmlFor="c-name" className="text-left font-semibold">
                    Date of birth<span className="text-primary-red">*</span>
                  </label>
                  <input
                    required=""
                    type="date"
                    placeholder="Address"
                    className="border-primary-red border p-3"
                    {...register("dob", { required: true })}
                  />
                </div>
                <div className="flex flex-col space-y-2">
                  <label htmlFor="c-name" className="text-left font-semibold">
                    PAN<span className="text-primary-red">*</span>
                  </label>
                  <input
                    required=""
                    type="number"
                    placeholder="Pan number"
                    className="border-primary-red border p-3"
                    {...register("pan_number", { required: true })}
                  />
                </div>
                <div className="flex flex-col space-y-2">
                  <label htmlFor="c-name" className="text-left font-semibold">
                    Citizenship Number
                    <span className="text-primary-red">*</span>
                  </label>
                  <input
                    required=""
                    type="number"
                    placeholder="Citizenship number"
                    {...register("citizen_number", { required: true })}
                    className="border-primary-red border p-3"
                  />
                </div>
              </div>
            </div>

            <div className="bg-primary-blue mt-5">
              <h1 className="py-2 px-3 text-left text-base font-bold text-white md:text-xl">
                Address Details
              </h1>
            </div>
            <div className="mt-5 flex flex-col gap-2 md:px-6 px-6 lg:px-0  ">
              <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
                <div className="flex flex-col space-y-2">
                  <label htmlFor="c-name" className="text-left font-semibold">
                    Temporary Address<span className="text-primary-red">*</span>
                  </label>

                  <input
                    id="capital-amount"
                    required=""
                    type="text"
                    placeholder="Temporary Address"
                    className="border-primary-red border p-3"
                    {...register("temporary_address", { required: true })}
                  />
                </div>
                <div className="flex flex-col space-y-2">
                  <label htmlFor="c-name" className="text-left font-semibold">
                    Pernament Address<span className="text-primary-red">*</span>
                  </label>
                  <input
                    required=""
                    type="text"
                    placeholder="Pernament Address"
                    className="border-primary-red border p-3"
                    {...register("permanent_address", { required: true })}
                  />
                </div>
              </div>
            </div>
            <div className="mt-14 mb-10">
              <button
                type="submit"
                className="hover:bg-primary-green animation rounded-md bg-green-500 px-16 py-4 text-center text-lg font-bold text-white"
              >
                Submit
              </button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
};

export default KycForm;
